const getObjectKey = (obj: any, value: string | number) => {
  return Object.keys(obj).find((key) => obj[key] === value);
};

export default getObjectKey;
